import { render, staticRenderFns } from "./FineAcquisto.vue?vue&type=template&id=1be1ab55&scoped=true&"
import script from "./FineAcquisto.vue?vue&type=script&lang=js&"
export * from "./FineAcquisto.vue?vue&type=script&lang=js&"
import style0 from "./FineAcquisto.vue?vue&type=style&index=0&id=1be1ab55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be1ab55",
  null
  
)

export default component.exports